import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { CarouselCard, WrapperComponent } from '../../../_imports.js';
import './blog_carousel.css';

function BlogCarousel({ posts }) {
    return (
        <WrapperComponent>
            <div className="carousel-wrapper">
                <Swiper
                    modules={[Autoplay, Pagination]}
                    spaceBetween={24}
                    slidesPerView={3}
                    loop={true}
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    breakpoints={{
                        320: { slidesPerView: 1, spaceBetween: 16 },
                        768: { slidesPerView: 2, spaceBetween: 20 },
                        1024: { slidesPerView: 3, spaceBetween: 24 },
                    }}
                    className="blog-carousel-swiper"
                >
                    {posts.map(post => (
                        <SwiperSlide key={post.id}>
                            <CarouselCard post={post} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </WrapperComponent>
    );
}

export default BlogCarousel;
